import { Component, OnInit } from '@angular/core';
import { BsAppLaunchFormService } from '../../services/bs-app-launch-form.service';
import { SelectFormControl } from './select.control';
import { BsAppLaunchFormControlBaseComponent } from '../bs-app-launch-form-control-base.component';

@Component({
  selector: 'app-bs-app-launch-select-control',
  templateUrl: './bs-app-launch-select-control.component.html',
  styleUrls: ['./bs-app-launch-select-control.component.scss']
})
export class BsAppLaunchSelectControlComponent extends BsAppLaunchFormControlBaseComponent<SelectFormControl> implements OnInit {
  formControl: SelectFormControl;

  constructor(bsAppLaunchFormService: BsAppLaunchFormService) {
    super(bsAppLaunchFormService);
  }

  ngOnInit() {
    this.toggle();

    // Track initial value
    this.formControl.trackValueForFormUpdates();

    this.subs.sink = this.formControl.valueChanges.subscribe(() => {
      this.toggle();

      // Check if value changed and emit
      this.checkAndFireFormUpdate();
      // Update tracked value after emitting
      this.formControl.trackValueForFormUpdates();
    });
  }

}
